import React from 'react';
import PropTypes from 'prop-types';

import PropertySubtype from './property_subtype';

export default function CompanyGridPropertySubtypes({ propertyType, onChange }) {
  return (
    <div className="company-grid-settings__property-subtypes d-flex flex-column flex-wrap text-nowrap">
      {Object.values(propertyType.subtypesById).map(subtype => (
        <PropertySubtype
          key={subtype.id}
          subtype={subtype}
          onChange={onChange}
        />
      ))}
    </div>
  );
}

CompanyGridPropertySubtypes.propTypes = {
  propertyType: PropTypes.shape({
    subtypesById: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};
